import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ObservablesService {
	sessionStop = new Subject<any>();
	sessionStart = new Subject<any>();
	pageUpdated = new Subject<pageUpdatedEvent>();
	pageUpdatedFinished = new Subject();
	modalUpdated = new Subject<any>();
	popUpUpdated = new Subject<any>();
	scrollToNextSectionFinished = new Subject<any>();
	scrollTop = new Subject<any>();
	unlockButtons = new Subject();
	showPreloader = new Subject<boolean>();
	showAjaxLoader = new Subject<boolean>();
	setheaderTop = new Subject();
	UpdateBinding = new Subject<any>();
	diffComponents: any;
	addressChanged = new Subject<any>();
	RadioButtonNumber: any;
	StyledButtonNumber: any;
	AddressError: boolean;
	ComparisonSectionVisible = new Subject<boolean>();
	OnlineBuyActive = new Subject<boolean>();
	insurerSelected = new Subject<any>();
	packageSelected = new Subject<any>();
	openSidebar = new Subject<any>();
	fetchStateAndCity = new Subject<any>();
	fetchAddresses = new Subject<any>();
	fireSplunkEvent = new Subject<any>();
	SubmissionLoaderCheckForResults = new Subject<any>();
	ShouldPageLoadEvent: string;
	preBridgeCall = new Subject<any>();
	constructor() {
		this.RadioButtonNumber = 0;
		this.StyledButtonNumber = 100;
	}
}
